export const GAUGE_DEFAULT_MINIMUM = 0;
export const GAUGE_DEFAULT_MAXIMUM = 100;
export const DEFAULT_SAML_NAME = 'SAML';
